module.exports = __webpack_public_path__ + "static/media/omdb-movies-movie-details-tablet.782bed05.jpg";